import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import { FloatingContact } from "./components/FloatingContact";
import Home from "./pages/HomeNew";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Solutions from "./pages/Solutions";
import About from "./pages/About";
import Contact from "./pages/Contact";
import CaseStudies from "./pages/CaseStudies";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Portal from "./pages/Portal";
import EVCharging from "./pages/EVCharging";
import Investor from "./pages/Investor";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import BlockShare from "./pages/BlockShare";
import CubiInvestors from "./pages/CubiInvestors";
import BlockSmartPage from "./pages/BlockSmart";
import StalledDev from "./pages/StalledDev";
import RepairCrisis from "./pages/RepairCrisis";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Toaster position="top-right" theme="dark" />
        <FloatingContact />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Navigate to="/" replace />} />
          <Route path="/products/:slug" element={<Navigate to="/" replace />} />
          <Route path="/solutions" element={<Navigate to="/" replace />} />
          <Route path="/ev-charging" element={<Navigate to="/" replace />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/case-studies" element={<CaseStudies />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/portal" element={<Portal />} />
          <Route path="/investor" element={<Investor />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/blockshare" element={<Navigate to="/cubi" replace />} />
          <Route path="/cubi" element={<CubiInvestors />} />
          <Route path="/cubi/stalled-development" element={<StalledDev />} />
          <Route path="/repair-crisis" element={<RepairCrisis />} />
          <Route path="/blocksmart" element={<BlockSmartPage />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
